import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { Button } from '../../ui/button';
import { 
  LineChart, 
  Line, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  Legend
} from 'recharts';
import { TrendingUp, BarChart3, PieChart as PieChartIcon, Target, FileText, Activity, CheckCircle, AlertTriangle } from 'lucide-react';


interface OverviewTabProps {
  data: ChartTypeBreakdownItem;
}
export interface ChartTypeBreakdownItem {
  chartTypeDistribution:{
    totalChartsProcessed: number;
    items:[]
  };
  processingVolumeTrends:[];
  chartTypeBreakdown:[];
  chartTypePerformance:{
    byVolume:[],
    byApprovalRate:[],
    needsAttention:[]
  };
  aiAuditorAgreementTrends:{
    correctionTrend:[],
    approvedTrend:[]
  }
}
interface chartTypeDistributionItem {
  percentage?:number;
  processed:number;
  chartType:string;
  totalProcessed?:number
  batches?:number
  approvalRate?:number

}

export function OverviewTab({ data }: OverviewTabProps) {
  const [aiAuditorViewMode, setAiAuditorViewMode] = useState<'approvals' | 'corrections'>('approvals');
  
  // Chart Type breakdown (previously domain breakdown)
  // const chartTypeBreakdown = React.useMemo(() => {
  //   const breakdown = new Map();
    
  //   data.forEach(batch => {
  //     const chartType = batch.chartType || 'Unknown';
  //     if (!breakdown.has(chartType)) {
  //       breakdown.set(chartType, {
  //         chartType,
  //         totalProcessed: 0,
  //         approved: 0,
  //         sentForCorrection: 0
  //       });
  //     }
      
  //     const item = breakdown.get(chartType);
  //     item.totalProcessed += batch.totalProcessed;
  //     item.approved += batch.approved;
  //     item.sentForCorrection += batch.sentForCorrection;
  //   });
    
  //   return Array.from(breakdown.values())
  //     .map(item => ({
  //       ...item,
  //       approvalRate: item.totalProcessed > 0 ? (item.approved / item.totalProcessed) * 100 : 0
  //     }))
  //     .sort((a, b) => b.totalProcessed - a.totalProcessed);
  // }, [data]);
// console.log(chartTypeBreakdown,"chartTypeBreakdown")
  // Chart Type Performance Analysis (previously program breakdown)
  // const chartTypePerformance = React.useMemo(() => {
  //   const breakdown = new Map();
    
  //   data.forEach(batch => {
  //     const chartType = batch.chartType || 'Unknown';
  //     if (!breakdown.has(chartType)) {
  //       breakdown.set(chartType, {
  //         chartType,
  //         totalProcessed: 0,
  //         approved: 0,
  //         sentForCorrection: 0,
  //         batchCount: 0
  //       });
  //     }
      
  //     const item = breakdown.get(chartType);
  //     item.totalProcessed += batch.totalProcessed;
  //     item.approved += batch.approved;
  //     item.sentForCorrection += batch.sentForCorrection;
  //     item.batchCount += 1;
  //   });
    
  //   return Array.from(breakdown.values())
  //     .map(item => ({
  //       ...item,
  //       approvalRate: item.totalProcessed > 0 ? (item.approved / item.totalProcessed) * 100 : 0,
  //       avgProcessedPerBatch: item.batchCount > 0 ? (item.totalProcessed / item.batchCount) : 0
  //     }))
  //     .sort((a, b) => b.totalProcessed - a.totalProcessed);
  // }, [data]);

  // Top/Bottom Chart Types by different metrics
  // const topChartTypes = {
  //   byVolume: [...chartTypePerformance].sort((a, b) => b.totalProcessed - a.totalProcessed).slice(0, 5),
  //   byApprovalRate: [...chartTypePerformance].sort((a, b) => b.approvalRate - a.approvalRate).slice(0, 5),
  //   byEfficiency: [...chartTypePerformance].sort((a, b) => b.avgProcessedPerBatch - a.avgProcessedPerBatch).slice(0, 5)
  // };

  // const bottomChartTypes = {
  //   byApprovalRate: [data?.byApprovalRate].sort((a, b) => a.approvalRate - b.approvalRate).slice(0, 3)
  // };
const AIVSAuditor=aiAuditorViewMode=== 'approvals'?data?.aiAuditorAgreementTrends?.approvedTrend:data?.aiAuditorAgreementTrends?.correctionTrend;
  const colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#F97316', '#06B6D4', '#84CC16', '#EC4899', '#6366F1', '#14B8A6', '#F97316'];

  return (
    <div className="space-y-6">
      {/* Time Series Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Volume Trends */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-blue-600" />
              Processing Volume Trends
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-80">
              {data?.processingVolumeTrends && data?.processingVolumeTrends?.length > 0 ? (
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={data?.processingVolumeTrends}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                    <XAxis dataKey="date" stroke="#6B7280" fontSize={11} />
                    <YAxis stroke="#6B7280" fontSize={11} />
                    <Tooltip 
                      contentStyle={{
                        backgroundColor: 'white',
                        border: '1px solid #E5E7EB',
                        borderRadius: '8px',
                        fontSize: '12px'
                      }}
                    />
                    <Line 
                      type="monotone" 
                      dataKey="totalProcessed" 
                      stroke="#3B82F6" 
                      strokeWidth={2}
                      name="Total Processed"
                      connectNulls={false}
                    />
                    <Line 
                      type="monotone" 
                      dataKey="approved" 
                      stroke="#10B981" 
                      strokeWidth={2}
                      name="Approved"
                      connectNulls={false}
                    />
                    <Line 
                      type="monotone" 
                      dataKey="sentForCorrection" 
                      stroke="#F59E0B" 
                      strokeWidth={2}
                      name="Send for Correction"
                      connectNulls={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              ) : (
                <div className="flex items-center justify-center h-full text-muted-foreground">
                  No data available for the selected period
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        {/* Quality & Approval Trends */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Activity className="w-5 h-5 text-blue-600" />
                AI vs Auditor Approval Trends
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant={aiAuditorViewMode === 'approvals' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setAiAuditorViewMode('approvals')}
                  className="h-8 px-3"
                >
                  <CheckCircle className="w-4 h-4 mr-1" />
                  Approvals
                </Button>
                <Button
                  variant={aiAuditorViewMode === 'corrections' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setAiAuditorViewMode('corrections')}
                  className="h-8 px-3"
                >
                  <AlertTriangle className="w-4 h-4 mr-1" />
                  Corrections
                </Button>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-80">
              {AIVSAuditor && AIVSAuditor?.length > 0 ? (
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={AIVSAuditor} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                    <XAxis 
                      dataKey="date" 
                      stroke="#6B7280" 
                      fontSize={11}
                      angle={-45}
                      textAnchor="end"
                      height={60}
                    />
                    <YAxis stroke="#6B7280" fontSize={11} />
                    <Tooltip 
                      contentStyle={{
                        backgroundColor: 'white',
                        border: '1px solid #E5E7EB',
                        borderRadius: '8px',
                        fontSize: '12px'
                      }}
                      formatter={(value: any, name: any) => {
                         const labels: Record<string, string> = {
      aiApprovedCount: "AI Approved",
      auditorApprovedCount: "Auditor Approved",
      aiCorrectionCount: "AI Send for Correction",
      auditorCorrectionCount: "Auditor Send for Correction",
    };
    return [
      Number(value).toLocaleString(),
      labels[name] || name
    ];
                      //   Number(value).toLocaleString(),

                      //   name === 'aiApprovedCount' ? 'AI Approved' : 
                      //   name === 'auditorApprovedCount' ? 'Auditor Approved' :
                      //   name === 'aiCorrectionCount' ? 'AI Sent for Correction' : 'Auditor Sent for Correction'
                      }}
                    />
                    <Legend />
                    {aiAuditorViewMode === 'approvals' ? (
                      <>
                        <Bar 
                          dataKey="aiApprovedCount" 
                          fill="#3B82F6" 
                          name="AI Approved"
                          radius={[4, 4, 0, 0]}
                        />
                        <Bar 
                          dataKey="auditorApprovedCount" 
                          fill="#10B981" 
                          name="Auditor Approved"
                          radius={[4, 4, 0, 0]}
                        />
                      </>
                    ) : (
                      <>
                        <Bar 
                          dataKey="aiCorrectionCount" 
                          fill="#F59E0B" 
                          name="AI Send for Correction"
                          radius={[4, 4, 0, 0]}
                        />
                        <Bar 
                          dataKey="auditorApprovedCount" 
                          fill="#EF4444" 
                          name="Auditor Send for Correction"
                          radius={[4, 4, 0, 0]}
                        />
                      </>
                    )}
                  </BarChart>
                </ResponsiveContainer>
              ) : (
                <div className="flex items-center justify-center h-full text-muted-foreground">
                  No data available for the selected period
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Chart Type Breakdown */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="w-5 h-5 text-purple-600" />
            Breakdown by Chart Type
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data?.chartTypeBreakdown} margin={{ left: 20, right: 20, bottom: 60 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                <XAxis 
                  dataKey="chartType" 
                  stroke="#6B7280" 
                  fontSize={10} 
                  angle={-45}
                  textAnchor="end"
                  height={80}
                />
                <YAxis stroke="#6B7280" fontSize={11} />
                <Tooltip 
                  contentStyle={{
                    backgroundColor: 'white',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    fontSize: '12px'
                  }}
                />
                <Bar dataKey="metrics.totalProcessed" fill="#3B82F6" name="Total Processed" />
                <Bar dataKey="metrics.aiApproved" fill="#10B981" name="Approved" />
                <Bar dataKey="metrics.aiSentForCorrection" fill="#F59E0B" name="Send for Correction" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>

      {/* Chart Type Analysis */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Chart Type Performance Table */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Target className="w-5 h-5 text-indigo-600" />
              Chart Type Performance
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <h4 className="text-sm font-medium text-muted-foreground mb-2">Top Performers by Volume</h4>
                <div className="space-y-2">
                  {data?.chartTypePerformance?.byVolume.map((chartType:chartTypeDistributionItem, index) => (
                    <div key={chartType?.chartType} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <div className="flex items-center gap-2">
                        <Badge variant="outline" className="text-xs">#{index + 1}</Badge>
                        <span className="text-sm font-medium">{chartType?.chartType}</span>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-muted-foreground">
                        <span>{chartType?.processed.toLocaleString()} processed</span>
                        <span>{chartType?.approvalRate}% approval</span>
                        <span>{chartType?.batches} batches</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-medium text-muted-foreground mb-2">Highest Approval Rates</h4>
                <div className="space-y-2">
                  {data?.chartTypePerformance?.byApprovalRate.map((chartType:chartTypeDistributionItem, index) => (
                    <div key={chartType?.chartType} className="flex items-center justify-between p-2 bg-green-50 rounded">
                      <div className="flex items-center gap-2">
                        <Badge variant="default" className="text-xs bg-green-600">#{index + 1}</Badge>
                        <span className="text-sm font-medium">{chartType?.chartType}</span>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-muted-foreground">
                        <span className="font-medium text-green-700">{chartType?.approvalRate}%</span>
                        <span>{chartType?.processed.toLocaleString()} processed</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* {bottomChartTypes.byApprovalRate.length > 0 && ( */}
                <div>
                  <h4 className="text-sm font-medium text-muted-foreground mb-2">Needs Attention (Low Approval Rate)</h4>
                  <div className="space-y-2">
                    {data?.chartTypePerformance?.needsAttention?.map((chartType:chartTypeDistributionItem) => (
                      <div key={chartType?.chartType} className="flex items-center justify-between p-2 bg-orange-50 rounded">
                        <div className="flex items-center gap-2">
                          <Badge variant="destructive" className="text-xs">⚠️</Badge>
                          <span className="text-sm font-medium">{chartType?.chartType}</span>
                        </div>
                        <div className="flex items-center gap-4 text-xs text-muted-foreground">
                          <span className="font-medium text-orange-700">{chartType?.approvalRate}%</span>
                          <span>{chartType?.processed.toLocaleString()} processed</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              {/* )} */}
            </div>
          </CardContent>
        </Card>

        {/* Chart Type Distribution */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <PieChartIcon className="w-5 h-5 text-blue-600" />
              Chart Type Distribution
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {/* Pie Chart */}
              <div className="h-48 flex items-center justify-center">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={data?.chartTypeDistribution?.items?.slice(0, 8)} // Show top 8 chart types
                      cx="50%"
                      cy="50%"
                      innerRadius={30}
                      outerRadius={60}
                      paddingAngle={2}
                      dataKey="processed"
                    >
                      {data?.chartTypeDistribution?.items?.slice(0, 8)?.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                      ))}
                    </Pie>
                    <Tooltip 
                      formatter={(value) => [
                        `${Number(value).toLocaleString()} charts`, 
                        'Processed'
                      ]}
                      contentStyle={{
                        backgroundColor: 'white',
                        border: '1px solid #E5E7EB',
                        borderRadius: '8px',
                        fontSize: '12px'
                      }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Custom Legend */}
              <div className="grid grid-cols-1 gap-2 max-h-40 overflow-y-auto">
                {data?.chartTypeDistribution?.items?.slice(0, 8).map((entry:chartTypeDistributionItem, index) => {
                  const totalProcessed = data?.chartTypeDistribution?.items?.reduce((sum, item) => sum + item.totalProcessed, 0);
                  const percentage = totalProcessed > 0 ? (entry.totalProcessed / totalProcessed) * 100 : 0;
                  
                  return (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                      <div className="flex items-center gap-2">
                        <div 
                          className="w-3 h-3 rounded-full flex-shrink-0" 
                          style={{ backgroundColor: colors[index % colors.length] }}
                        />
                        <span className="text-xs font-medium truncate max-w-[120px]" title={entry.chartType}>
                          {entry.chartType}
                        </span>
                      </div>
                      <div className="text-right flex-shrink-0 ml-2">
                        <div className="text-xs font-bold" style={{ color: colors[index % colors.length] }}>
                          {entry.processed.toLocaleString()}
                        </div>
                        <div className="text-xs text-muted-foreground">
                          {/* {percentage.toFixed(1)}% */}
                          {entry?.percentage}%
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              {/* Summary */}
              <div className="pt-3 border-t text-center">
                <div className="text-xs text-muted-foreground mb-1">
                  Total Charts Processed
                </div>
                <div className="text-lg font-bold">
                  {/* {chartTypeBreakdown.reduce((sum, item) => sum + item.totalProcessed, 0).toLocaleString()}
                   */}
                   {data?.chartTypeDistribution?.totalChartsProcessed?.toLocaleString()}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}